import { GITLAB_ANNOTATION, GITLAB_JOBS_ANNOTATION } from '../utils/constants/index.esm.js';

const isGitlabAvailable = (entity) => !!entity?.metadata.annotations?.[GITLAB_ANNOTATION];
const isGitlabJobsAvailable = (entity) => !!entity?.metadata.annotations?.[GITLAB_JOBS_ANNOTATION];

export { isGitlabAvailable, isGitlabJobsAvailable };
//# sourceMappingURL=useGitlabAvaliable.esm.js.map
